package dev.lingvo.site.pages.app.projects.slug.screenshots

import androidx.compose.runtime.Composable
import com.varabyte.kobweb.compose.foundation.layout.Column
import com.varabyte.kobweb.compose.ui.Modifier
import com.varabyte.kobweb.compose.ui.modifiers.gap
import dev.lingvo.shared.screenshots.doc.BrandKit
import dev.lingvo.site.components.studio.preview.DesignLooksPort
import dev.lingvo.site.ds.LButton
import dev.lingvo.site.ds.LButtonVariant
import dev.lingvo.site.ds.LColorField
import dev.lingvo.site.ds.LMuted
import dev.lingvo.site.ds.LSectionHeading
import dev.lingvo.site.ds.LSelect
import dev.lingvo.site.ds.LSelectOption
import dev.lingvo.site.ds.Space
import dev.lingvo.site.i18n.t

/** Curated font coverage is explicit so the fallback is understandable before a language switch. */
@Composable
internal fun BrandPanel(
    brand: BrandKit, looks: DesignLooksPort, canWrite: Boolean, hasIcon: Boolean,
    onColors: (String?, String?) -> Unit, onFonts: (String?, String?) -> Unit, onIcon: () -> Unit,
) {
    Column(Modifier.gap(Space.MD)) {
        LSectionHeading(t("app.projects.slug.screenshots.brand_panel.brand", "Brand"), description = t("app.projects.slug.screenshots.brand_panel.choose_colours_and_fonts_for_every", "Choose colours and fonts for every shot."))
        if (canWrite) {
            val swatches = (listOfNotNull(brand.primary, brand.secondary) + brand.iconPalette).distinct().take(6)
            LColorField(brand.primary, { onColors(it, brand.secondary) }, label = t("app.projects.slug.screenshots.brand_panel.primary", "Primary colour"), swatches = swatches)
            LColorField(brand.secondary, { onColors(brand.primary, it) }, label = t("app.projects.slug.screenshots.brand_panel.secondary", "Secondary colour"), swatches = swatches)
            if (hasIcon) LButton(t("app.projects.slug.screenshots.brand_panel.icon", "Use colours from the project icon"), onClick = onIcon, variant = LButtonVariant.SECONDARY)
            val options = listOf(LSelectOption("", t("app.projects.slug.screenshots.brand_panel.template", "Template font"))) +
                looks.fontFamilies().map { font -> LSelectOption(font.name, font.name + " · " + font.scripts.joinToString { it.name.lowercase() }) }
            LSelect(brand.displayFamily.orEmpty(), options, { onFonts(it.ifEmpty { null }, brand.textFamily) }, label = t("app.projects.slug.screenshots.brand_panel.heading", "Heading font and script coverage"))
            LSelect(brand.textFamily.orEmpty(), options, { onFonts(brand.displayFamily, it.ifEmpty { null }) }, label = t("app.projects.slug.screenshots.brand_panel.body", "Body font and script coverage"))
        } else {
            LMuted(listOfNotNull(brand.primary, brand.secondary, brand.displayFamily, brand.textFamily).joinToString(" · "))
        }
    }
}
